import type { RouteObject } from "react-router-dom";
import { CustomersPage } from "@/modules/customers/pages/CustomersPage";

export const customersRoutes: RouteObject[] = [
  {
    path: "customers",
    element: <CustomersPage />,
  },
];
